(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-unified-products]').forEach((section) => {
    const items = [...section.querySelectorAll('[data-unified-product]')];
    const button = section.querySelector('[data-unified-more]');
    const step = Number(section.dataset.stepCount) || 12;
    if (!button) return;
    button.addEventListener('click', () => {
      items.filter((item) => item.classList.contains('is-hidden')).slice(0, step).forEach((item) => item.classList.remove('is-hidden'));
      if (!items.some((item) => item.classList.contains('is-hidden'))) button.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-expand-collection]');
    if (!button) return;
    const grid = document.getElementById(button.dataset.expandCollection);
    if (!grid || button.disabled) return;
    button.disabled = true;
    grid.setAttribute('aria-busy', 'true');
    const items = Array.from(document.querySelectorAll(`template[data-zuqo-lazy-product="${button.dataset.expandCollection}"]`));
    const batchSize = window.matchMedia('(max-width: 749px)').matches ? 4 : 12;
    let index = 0;
    const appendBatch = () => {
      const additions = document.createDocumentFragment();
      for (let count = 0; count < batchSize && index < items.length; count++, index++) {
        const item = items[index];
        const content = item.content.cloneNode(true);
        content.querySelectorAll('.scroll-trigger').forEach((element) => {
          element.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
          element.style.removeProperty('--animation-order');
        });
        additions.appendChild(content);
        item.remove();
      }
      grid.appendChild(additions);
      if (index < items.length) setTimeout(appendBatch, 0);
      else {
        grid.removeAttribute('aria-busy');
        button.setAttribute('aria-expanded', 'true');
        button.closest('.collection__view-all')?.remove();
      }
    };
    appendBatch();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.product__text--hot-selling').forEach(label=>{if(!('IntersectionObserver'in window)){label.classList.add('is-visible');return}new IntersectionObserver((entries,observer)=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.5}).observe(label)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zuqo-category-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-zuqo-category-toggle]');
    if (!toggle) return;
    const section = toggle.closest('.zuqo-category');
    const cards = section.querySelectorAll('.zuqo-category__card--extra');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    cards.forEach((card) => { card.hidden = !expanded ? false : true; });
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.querySelector('[data-expand-label]').hidden = !expanded;
    toggle.querySelector('[data-collapse-label]').hidden = expanded;
    if (expanded) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zuqo-product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-expand-showcase]');
    if (!button) return;
    const grid = document.getElementById(button.dataset.expandShowcase);
    if (!grid) return;
    document.querySelectorAll(`template[data-zuqo-lazy-product="${button.dataset.expandShowcase}"]`).forEach((item) => {
      grid.appendChild(item.content.cloneNode(true));
      item.remove();
    });
    button.closest('.zuqo-products__footer')?.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zuqo-video-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-video-track]');
    const panels = [...gallery.querySelectorAll('[data-video-panel]')];
    const dots = [...gallery.querySelectorAll('[data-video-target]')];
    const viewport = gallery.querySelector('.zuqo-video-carousel__viewport');
    const desktop = window.matchMedia('(min-width: 990px)');
    let inViewport = !('IntersectionObserver' in window);
    const syncSound = (video) => {
      const button = video.closest('[data-video-panel]').querySelector('[data-video-sound]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute('aria-label', video.muted ? button.dataset.labelOn : button.dataset.labelOff);
    };
    panels.forEach((panel) => {
      const video = panel.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.addEventListener('volumechange', () => syncSound(video));
      syncSound(video);
    });
    const startVideo = (video) => {
      if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
      if (video.dataset.zuqoLoaded !== 'true') {
        video.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; });
        video.dataset.zuqoLoaded = 'true';
        video.load();
      }
      video.play().catch(() => {});
    };
    let activeIndex = 0;
    let gesture = null;
    let suppressClickUntil = 0;
    const show = (index, move = true) => {
      if (!panels.length) return;
      const visibleCount = desktop.matches ? 4 : 1;
      const positions = Math.max(1, panels.length - visibleCount + 1);
      activeIndex = (index + positions) % positions;
      const step = desktop.matches ? panels[0].getBoundingClientRect().width + 28 : viewport.clientWidth;
      if (desktop.matches) {
        viewport.scrollLeft = 0;
        track.style.transform = `translate3d(-${activeIndex * step}px,0,0)`;
      } else {
        track.style.transform = 'none';
        if (move) viewport.scrollTo({ left: activeIndex * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      panels.forEach((panel, panelIndex) => {
        const active = panelIndex >= activeIndex && panelIndex < activeIndex + visibleCount;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', String(!active));
        const video = panel.querySelector('video');
        if (!active) video?.pause();
        else if (video && inViewport && !document.hidden) startVideo(video);
      });
      dots.forEach((dot, dotIndex) => {
        dot.hidden = dotIndex >= positions;
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };
    gallery.addEventListener('click', (event) => {
      const sound = event.target.closest('[data-video-sound]');
      if (sound) {
        const video = sound.closest('[data-video-panel]').querySelector('video');
        if (!video) return;
        const enableSound = video.muted;
        if (enableSound) panels.forEach((panel) => {
          const other = panel.querySelector('video');
          if (other && other !== video) { other.muted = true; syncSound(other); }
        });
        video.muted = !enableSound;
        syncSound(video);
        startVideo(video);
        return;
      }
      const dot = event.target.closest('[data-video-target]');
      if (dot) show(dots.indexOf(dot));
      if (event.target.closest('[data-video-prev]')) show(activeIndex - 1);
      if (event.target.closest('[data-video-next]')) show(activeIndex + 1);
    });
    viewport?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(activeIndex - 1);
      if (event.key === 'ArrowRight') show(activeIndex + 1);
    });
    viewport?.addEventListener('pointerdown', (event) => {
      if (!desktop.matches) return;
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (event.target.closest('button, a')) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      viewport.setPointerCapture?.(event.pointerId);
    });
    viewport?.addEventListener('pointerup', (event) => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const deltaX = event.clientX - gesture.x;
      const deltaY = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(deltaX) >= 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
        suppressClickUntil = Date.now() + 400;
        show(activeIndex + (deltaX < 0 ? 1 : -1));
      }
    });
    viewport?.addEventListener('pointercancel', () => { gesture = null; });
    viewport?.addEventListener('lostpointercapture', () => { gesture = null; });
    viewport?.addEventListener('dragstart', (event) => { event.preventDefault(); });
    viewport?.addEventListener('click', (event) => {
      if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    let scrollFrame = null;
    viewport?.addEventListener('scroll', () => {
      if (desktop.matches || scrollFrame !== null) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = null;
        if (desktop.matches || !viewport.clientWidth) return;
        const index = Math.max(0, Math.min(panels.length - 1, Math.round(viewport.scrollLeft / viewport.clientWidth)));
        if (index !== activeIndex) show(index, false);
      });
    }, { passive: true });
    window.addEventListener('resize', () => show(activeIndex));
    const syncPlayback = () => {
      panels.forEach((panel) => {
        const video = panel.querySelector('video');
        if (!video) return;
        if (inViewport && !document.hidden && panel.classList.contains('is-active')) startVideo(video);
        else video.pause();
      });
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        inViewport = entries[0].isIntersecting;
        syncPlayback();
      }, { rootMargin: '200px 0px', threshold: 0 });
      observer.observe(gallery);
    }
    document.addEventListener('visibilitychange', syncPlayback);
    show(0);
  });


  } catch(e) { console.error(e); }
})();
})();
